import { loadDetailSheetData } from '@/api/report';
import { formatTimeStr, timeFormat } from '@/utils/other';
import {
  changeCreatorOption,
  changeOwnerOption,
  changeQuotationCategoryOption,
  changeSettlementUnitOption,
  changeStatusOption,
  changeTypeOption,
} from './uitls';

type IDetailSheetClass = IReport.IDetailSheet.IDetailSheetClass;
type IDataInfo = IReport.IDetailSheet.IDataInfo;
type IRequestDetailSheetParams = IReport.IDetailSheet.IRequestDetailSheetParams;
type IOptionInfo = IReport.IOptionInfo;

class DetailSheetClass implements IDetailSheetClass {
  private $data: IDataInfo[] = [];
  get data() {
    return this.$data;
  }
  public requestData(params: IRequestDetailSheetParams): Promise<string> {
    return new Promise((reslove, reject) => {
      loadDetailSheetData(params).then((res) => {
        this.$updateData(res.data);
        if (res.data.length > 0) {
          reslove(res.message);
        } else {
          reject('暂无数据');
        }
      }).catch((error) => {
        reject(error.message);
      });
    });
  }
  public clearData() {
    this.$data = [];
  }
  private $updateData(data: IDataInfo[]) {
    data.sort((a, b) => new Date(a.due).valueOf() - new Date(b.due).valueOf());
    this.$data = data.map((item) => {
      item.due = item.due ? formatTimeStr(item.due, 'YYYY-MM-DD') : '';
      item.settlementDate = item.settlementDate ? timeFormat(item.settlementDate, 'YYYY-MM-DD') : '';
      return item;
    });
  }
}

export const generateOptions = (reportData: IDataInfo[]): IReport.IDetailSheet.IFilterOption => {
  const typeOption: IOptionInfo[] = [];
  const ownerOption: IOptionInfo[] = [];
  const statusOption: IOptionInfo[] = [];
  const creatorOption: IOptionInfo[] = [];
  const settlementUnitOption: IOptionInfo[] = [];
  const quotationCategoryOption: IOptionInfo[] = [];
  const typeIds: string[] = [];
  const ownerIds: string[] = [];
  const statusTxts: string[] = [];
  const createIds: string[] = [];
  const quotationCategoryTxts: string[] = [];
  const settlementUnitTxts: string[] = [];
  reportData.forEach((item) => {
    changeTypeOption(item, typeIds, typeOption);
    changeOwnerOption(item, ownerIds, ownerOption);
    changeStatusOption(item, statusTxts, statusOption);
    changeCreatorOption(item, createIds, creatorOption);
    changeSettlementUnitOption(item, settlementUnitTxts, settlementUnitOption);
    changeQuotationCategoryOption(item, quotationCategoryTxts, quotationCategoryOption);
  });
  return {
    typeOption,
    ownerOption,
    statusOption,
    creatorOption,
    settlementUnitOption,
    quotationCategoryOption,
  };
};

export const detailSheetInstance = new DetailSheetClass();
